<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  {{ titolo }}
  <button class="custom-close" mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</h1>
<div mat-dialog-content>
  <div class="voce-legenda" *ngFor="let voce of voci">
    <span class="swatch" [style.background-color]="voce.colore"></span>
    <span>{{ voce.classe }}</span>
  </div>
</div>